import styled from 'styled-components';

export const ExceptionalTimeSpan = styled.span`
  display: block;
`;



// WEBPACK FOOTER //
// ./components/ExceptionalTimes/ExceptionalTimes.style.js